/**
 * rambler.ru — hesaplar & ham kontrol düzlemi (R-RAMBLER, 2026-09-15 audit).
 *
 * The stock/site-usage dashboard (RamblerPage) answers the operator's numbers;
 * THIS mount is the account-level surface the audit found unreachable: the
 * account list (status, lastSeen, credential), the TXT import, readiness and
 * the outbox tail — the SAME agnostic page stack mail.com/gmx use, bound to
 * providerId='rambler' with the alias-model mutations switched off (the API
 * refuses them with 409 for a site-scoped provider anyway).
 */
import { MailcomPage } from '../mailcom/MailcomPage.js';

export function RamblerRawPage(): JSX.Element {
  return <MailcomPage providerId="rambler" providerLabel="rambler.ru" aliasOps={false} />;
}
